import * as Sentry from '@sentry/core';

const addBreadcrumb = (breadcrumb, msg) => Sentry.addBreadcrumb({
  category: breadcrumb,
  message: msg
});
const captureException = (error, captureContext) => Sentry.captureException(error, captureContext);
const logApliClientError = error => {
  if (error.status && error.status < 500) {
    error.log();
  }
};

export { addBreadcrumb, captureException, logApliClientError };
//# sourceMappingURL=Logger.js.map
